import {Action} from '../../actions/index';
import {ActionTypes, FetchPpcConfigFulfilledPayload, PpcConfigState} from './types';
import {FailedRequestPayload} from '../types';

const initialState: PpcConfigState = {
  loadingPpcConfig: true,
  fetchedPpcConfig: false,
  ppcConfigError: null
};

const ppcConfigReducer = (state: PpcConfigState = initialState, action: Action): PpcConfigState => {
  switch (action.type) {
    case ActionTypes.FETCH_PPC_CONFIG_PENDING: {
      return {
        ...state,
        loadingPpcConfig: true,
        fetchedPpcConfig: false,
        ppcConfigError: null
      };
    }
    case ActionTypes.FETCH_PPC_CONFIG_FULFILLED: {
      const ppcConfigData = action.payload as FetchPpcConfigFulfilledPayload;
      return {
        ...state,
        ...ppcConfigData,
        loadingPpcConfig: false,
        fetchedPpcConfig: true,
        ppcConfigError: null
      };
    }
    case ActionTypes.FETCH_PPC_CONFIG_REJECTED: {
      const {error} = action.payload as FailedRequestPayload;
      return {
        ...state,
        loadingPpcConfig: false,
        fetchedPpcConfig: false,
        ppcConfigError: error
      };
    }
    default: {
      return state;
    }
  }
};

export default ppcConfigReducer;
